// @owners { team: patients }
import { COLORS, SPACING } from '@alto/design-library-tokens';
import { Body, Button, Card, H1, H3, MdPadding, SecondaryPage, SmPadding, SmSpacing } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import React from 'react';
import { getCompanyName } from '~shared/config/getCompanyName';
import { ASSISTANT_VIEWED_EVENTS } from '~shared/features/alto-assistant/analytics/constants';
import { usePageViewedEvent } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';

export const PriceConfirmation = () => {
  const { getParam, navigate } = useNavigation<'RoutePriceConfirmation'>();
  const onPressConfirm = getParam('onPressConfirm', undefined);

  usePageViewedEvent({
    event: EVENTS.ASSISTANT_COMPONENT_VIEWED,
    params: { name: ASSISTANT_VIEWED_EVENTS.PRICE_CONFIRMATION_PAGE },
  });

  return (
    <SecondaryPage
      HeaderContent={
        <MdPadding>
          <H1>Price confirmation</H1>
        </MdPadding>
      }
      backgroundColor={COLORS.BACKGROUND_COLORS.PRIMARY_LIGHTEST}
      onDismiss={() => {
        navigate('RouteAppTabNavigator', { screen: 'RouteTabHomescreen' });
      }}
      dismissIcon="chevronleft"
      buttons={
        onPressConfirm
          ? [
              <Button
                key="confirm"
                label="Confirm new price"
                onPress={onPressConfirm}
              />,
            ]
          : undefined
      }
    >
      <Card>
        <MdPadding>
          <H3>Understand why prices change</H3>
          <SmSpacing />
          <Body>The most common reasons for price changes are:</Body>
          <SmPadding rightPadding={SPACING.STATIC.NONE}>
            <Body>
              &bull;
              <SmSpacing />
              Changes to insurance coverage due to plan deductibles, coverage gaps, formulary updates
            </Body>
            <Body>
              &bull;
              <SmSpacing />
              New insurance coverage
            </Body>
            <Body>
              &bull;
              <SmSpacing />
              Coupon expiration, changes to coupon terms and conditions
            </Body>
          </SmPadding>
          <Body>
            As a reminder, {getCompanyName()} does not set the price of your medications covered by insurance or other
            discount cards. The prices you see here reflect the most up-to-date pricing offered by these parties.
          </Body>
        </MdPadding>
      </Card>
    </SecondaryPage>
  );
};
